import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Angular Material Modules
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

// Translation
import { TranslateModule } from '@ngx-translate/core';

// Chart.js
import { BaseChartDirective } from 'ng2-charts';

// Components
import { LanguageSwitcherComponent } from './components/language-switcher/language-switcher.component';
import { LocalizationDemoComponent } from './components/localization-demo/localization-demo.component';
import { FormErrorComponent } from './components/form-error/form-error.component';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { ListFiltersComponent } from './components/list-filters/list-filters.component';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { CardComponent } from './components/card/card.component';
import { SessionTimeoutDialogComponent } from './components/session-timeout-dialog/session-timeout-dialog.component';

// Chart Components
import { LineChartComponent } from './components/charts/line-chart/line-chart.component';
import { BarChartComponent } from './components/charts/bar-chart/bar-chart.component';
import { PieChartComponent } from './components/charts/pie-chart/pie-chart.component';

// User Guide
import { UserGuideDialogComponent } from './components/user-guide-dialog/user-guide-dialog.component';

// Confirmation Dialog
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';

// Directives
import { HasPermissionDirective } from '../core/directives/has-permission.directive';

const MATERIAL_MODULES = [
  MatButtonModule,
  MatCardModule,
  MatFormFieldModule,
  MatInputModule,
  MatIconModule,
  MatToolbarModule,
  MatSidenavModule,
  MatListModule,
  MatTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatDialogModule,
  MatSnackBarModule,
  MatProgressSpinnerModule,
  MatProgressBarModule,
  MatSelectModule,
  MatCheckboxModule,
  MatRadioModule,
  MatDatepickerModule,
  MatTimepickerModule,
  MatNativeDateModule,
  MatTabsModule,
  MatExpansionModule,
  MatChipsModule,
  MatAutocompleteModule,
  MatBadgeModule,
  MatMenuModule,
  MatTooltipModule,
  MatSlideToggleModule,
  MatDividerModule,
  MatButtonToggleModule,
];

@NgModule({
  declarations: [
    LanguageSwitcherComponent,
    LocalizationDemoComponent,
    FormErrorComponent,
    EmptyStateComponent,
    ListFiltersComponent,
    MainLayoutComponent,
    CardComponent,
    SessionTimeoutDialogComponent,
    LineChartComponent,
    BarChartComponent,
    PieChartComponent,
    UserGuideDialogComponent,
    ConfirmationDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    BaseChartDirective,
    HasPermissionDirective,
    ...MATERIAL_MODULES,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    BaseChartDirective,
    HasPermissionDirective,
    ...MATERIAL_MODULES,
    LanguageSwitcherComponent,
    LocalizationDemoComponent,
    FormErrorComponent,
    EmptyStateComponent,
    ListFiltersComponent,
    MainLayoutComponent,
    CardComponent,
    SessionTimeoutDialogComponent,
    LineChartComponent,
    BarChartComponent,
    UserGuideDialogComponent,
    PieChartComponent,
  ],
})
export class SharedModule {}
